module.exports = require("@carvana/icons/ArrowUpFilled");